// components
import RoomsPage from '../components/roomsPage';
import { serverSideTranslations } from '../lib/serverSideTranslations';
import { useTranslation } from '../utils/i18n';

const BookMinorOperationsRoomsPage = () => {
  const { t } = useTranslation('common');

  return (
    <RoomsPage
      roomType="minor_operations"
      title={t('room_types_landing_page.minor_operations.title')}
      roomCategory={t('shared.clinical').toLowerCase()}
      headerTitle={t('headers.minor_operations.title')}
      headerDescription={t('headers.minor_operations.description')}
    />
  );
};

export const getServerSideProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default BookMinorOperationsRoomsPage;
